import React, { useState, useEffect } from "react";
import "../styles/Home.css";
import { FaFacebookSquare, FaInstagram, FaTwitterSquare } from "react-icons/fa";

const departments = [
  {
    src: "/Nurseimage1.webp",
    alt: "Nursing",
    title: "SAROJINI COLLEGE OF NURSING, DHULE",
    heading: "Nursing (GNM)",
    campus: "Dhule Campus",
    info: "Our GNM program provides students with strong foundations in patient care, nursing management, and community health, including hands-on clinical experience and compassionate skill development.",
  },
  {
    src: "/DMLTimage1.webp",
    alt: "Medical Laboratory Technology (DMLT)",
    title: "SAROJINI INSTITUTE, DHULE",
    heading: "DMLT",
    campus: "Dhule Campus",
    info: "DMLT offers comprehensive training in clinical laboratory techniques and medical diagnostics, preparing students for essential roles in healthcare laboratories.",
  },
  {
    src: "/Physiotherapyphoto1.webp",
    alt: "Physiotherapy",
    title: "SAROJINI INSTITUTE, DHULE",
    heading: "Physiotherapy",
    campus: "Dhule Campus",
    info: "Our Physiotherapy program prepares students for careers in rehabilitation and physical therapy, with a focus on patient mobility, recovery, and modern therapeutic practices.",
  },
];

const sliderImages = [
  "/Sarojini_College_1.png",
  "/Nurseimage1.webp",
  "/DMLTimage1.webp",
  "/Physiotherapyphoto1.webp",
];

export default function Home() {
  const [sliderIdx, setSliderIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setSliderIdx((i) => (i + 1) % sliderImages.length);
    }, 3200);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="home-purple-wrapper">
      {/* Top Purple Strip */}
      <div className="sgi-top-purple-strip"></div>

      {/* Header (centered on mobile) */}
      <div className="sgi-header-top">
        <div className="sgi-header-center">
          <img
            src="/scn1.png"
            alt="Sarojini College Logo"
            className="sgi-header-logo"
          />
          <div className="sgi-header-text">
            <div className="sgi-header-foundation">AADHAR FOUNDATION'S</div>
            <div className="sgi-header-title-heavy">
              SAROJINI GROUP OF INSTITUTES
            </div>
          </div>
        </div>
      </div>

      {/* Welcome Scroll */}
      <div className="sgi-welcome-scrollbar">
        <div className="sgi-welcome-scroll-content">
          <span className="sgi-welcome-scroll-welcome">
            WELCOME TO SAROJINI GROUP OF INSTITUTES | EMPOWERING FUTURE HEALTHCARE PROFESSIONALS |
            ADMISSION ENQUIRY: 8275122933, 8275122944
          </span>
        </div>
      </div>

      {/* Image Slider */}
      <div className="sgi-slider-row">
        <img
          src={sliderImages[sliderIdx]}
          alt={`Slider ${sliderIdx + 1}`}
          className="sgi-slider-image"
        />
      </div>

      {/* Intro Section */}
      <div className="sgi-intro-section">
        <h2 className="sgi-intro-title">SAROJINI GROUP OF INSTITUTES </h2>
        <p className="sgi-intro-text">
          Sarojini Group of Institutes, Dhule, established under the vision of
          Aadhar Foundation, is committed to nurturing competent and
          compassionate healthcare professionals who contribute to society with
          dedication and integrity.
        </p>
      </div>

      {/* Department Cards */}
      <div className="department-container">
        {departments.map((dept, idx) => (
          <div className="department-card-zensung" key={idx}>
            <h3 className="dept-title">{dept.title}</h3>
            <img src={dept.src} alt={dept.alt} className="dept-img" />
            <div className="dept-info">
              <h4 className="dept-heading">{dept.heading}</h4>
              <p className="dept-campus">{dept.campus}</p>
              <p className="dept-description">{dept.info}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <footer className="sgi-footer">
        <div className="sgi-footer-inner">
          <div className="sgi-footer-col sgi-footer-logo">
            <img
              src="/scn1.png"
              alt="Sarojini College Logo"
              className="sgi-footer-logo-img"
            />
            <div className="sgi-footer-title">
              SAROJINI GROUP OF INSTITUTES
            </div>
            <div className="sgi-footer-address">
              32, Saroday Colony, Nr. New City High School, Dhule – 424001
              <br />
              <span className="sgi-footer-campus">Songir Highway Road, Dhule</span>
              <div className="sgi-footer-phone">
                <span>📞</span> 02562-238754, 8275122933, 8275122944
              </div>
              <div className="sgi-footer-email">
                <span>✉️</span>{" "}
                <a href="mailto:sarojinicollegeofnursing@gmail.com">
                  sarojinicollegeofnursing@gmail.com
                </a>
              </div>
            </div>
          </div>

          <div className="sgi-footer-col sgi-footer-links">
            <div className="sgi-footer-heading">USEFUL LINKS</div>
             <ul>
              <li><a href="https://www.muhs.ac.in/" target="_blank" rel="noopener noreferrer">MUHS Digital Library</a></li>
              <li><a href="https://www.indianursingcouncil.org/" target="_blank" rel="noopener noreferrer">Indian Nursing Council</a></li>
              <li><a href="https://www.maharashtranursingcouncil.org/" target="_blank" rel="noopener noreferrer">Maharashtra Nursing Council</a></li>
              <li><a href="https://www.dmer.org/" target="_blank" rel="noopener noreferrer">Directorate of Medical Education and Research</a></li>
              <li><a href="https://www.mahacet.org/" target="_blank" rel="noopener noreferrer">MHT-CET</a></li>
              <li><a href="https://www.nmc.org.in/" target="_blank" rel="noopener noreferrer">National Medical Commission</a></li>
              <li><a href="https://www.msbnp.org/" target="_blank" rel="noopener noreferrer">Maharashtra State Board of Nursing and Paramedical Education</a></li>
              <li><a href="https://www.ugc.ac.in/" target="_blank" rel="noopener noreferrer">UGC</a></li>
              <li><a href="https://www.who.int/" target="_blank" rel="noopener noreferrer">World Health Organization</a></li>
              <li><a href="https://aishe.gov.in/" target="_blank" rel="noopener noreferrer">AISHE Portal</a></li>
              <li><a href="https://mahadbt.maharashtra.gov.in/" target="_blank" rel="noopener noreferrer">MahaDBT Portal</a></li>
              <li><a href="https://ndcsss.info/" target="_blank" rel="noopener noreferrer">NDCSSS Portal</a></li>
            </ul>
          </div>

          <div className="sgi-footer-col sgi-footer-hours">
            <div className="sgi-footer-heading">OPENING HOURS</div>
            <ul>
              <li>Mon–Sat: 9:30 am to 5:30 pm</li>
              <li>Counter 1 (Account): 10 am to 5 pm</li>
              <li>Counter 2 (Documents): 2 pm to 5 pm</li>
              <li>Counter 3 (Documents): 2 pm to 5 pm</li>
            </ul>
            <div className="sgi-footer-heading">CONNECT WITH US</div>
            <div className="sgi-footer-social-icons">
              <a href="https://facebook.com/" target="_blank" rel="noreferrer">
                <FaFacebookSquare />
              </a>
              <a href="https://instagram.com/" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
              <a href="https://twitter.com/" target="_blank" rel="noreferrer">
                <FaTwitterSquare />
              </a>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "30px", textAlign: "center", fontSize: "12px", opacity: 0.7 }}>
          <div>© 2026 Sarojini Group of Institutes. All Rights Reserved.</div>
          Designed & Developed by{" "}
          <a href="https://hrudyansha.com" target="_blank" rel="noreferrer">
            Hrudyansha Software
          </a>
        </div>
      </footer>
    </div>
  );
}